import * as d3 from 'd3'

export default {
  methods: {
    draw_SkylineCharts() {

      let self = this
      let sky = this.skyline
      let boxX = sky.gap

      this.canvasSkyline = this.svg
      .append('g')
      .attr('id', 'SKYLINE')
      .attr('transform', `translate(${this.timeline.x}, 0)`)
      .attr('font-family', 'roboto')

      this.timeline.week.filter(f => f.sum <= this.timeline.maxCol).forEach((w, j) => {

        let hovorScale = 1.4
        let y_ = this.timeline.y - sky.height - sky.gap
        let periodData = this.filteredData.filter(f => f.cDate == w.eDate)
        let peakY = 0

        periodData.forEach((d, i) => {
          if (i != 0 && i % sky.maxBox == 0) {
            boxX += sky.width + (sky.gap * 2)
            y_ = this.timeline.y - sky.height - sky.gap
          }

          let x1 = boxX + sky.gap / 2
          let y1 = y_
          let width_ = sky.width - sky.gap / 2

          let Boxes = this.canvasSkyline
          .append('g')
          .attr('id', `BOX_${d[this.selectStage.code]}`)
          .attr('transform', `translate(${x1},${y1})`)
          .style('cursor', 'pointer')
          .on('mouseover', function() {
            let factor = (hovorScale - 1) / 2
            let scale_x = width_ * factor
            let scale_y = self.skyline.height * factor
            d3.select(this).moveToFront().transition().duration(150)
            .attr('transform', `translate(${x1-scale_x},${y1-scale_y}) scale(${hovorScale})`)

          })
          .on('mouseout', function(){
            d3.select(this).transition().duration(150).attr('transform', `translate(${x1},${y1}) scale(1)`)
            // d3.select('#DETAIL').transition().delay(500).duration(300).attr('opacity', self.detail.onOff == 'ON' ? 1 : 0)
          })
          .on('click', () => {
            this.link_Skyline(d)
          })

          Boxes
          .append('rect')
          .attr('rx', sky.radius).attr('ry', sky.radius)
          .attr('width', width_).attr('height', sky.height)
          .attr('fill', '#fff')
          

          Boxes
          .append('rect')
          .attr('rx', sky.radius).attr('ry', sky.radius)
          .attr('width', d.proRef ? width_ * (d[d.proRef]/100) : width_)
          .attr('height', sky.height)
          .attr('fill', d.bColor).attr('opacity', d.opacity)


          Boxes
          .append('rect')
          .attr('rx', sky.radius).attr('ry', sky.radius)
          .attr('width', width_).attr('height', sky.height)
          .attr('fill', 'none')
          .attr('stroke', d.stroke ? d.stroke : '#9E9E9E')
          .attr('stroke-width', d.sWidth ? d.sWidth : .5)


          Boxes
          .append('text')
          .attr('x', width_/2).attr('y', sky.height/2 + d.tSize*0.36)
          .attr('font-size', d.tSize).attr('fill', sky.tColor)
          .attr('text-anchor', 'middle')
          .style('pointer-events', 'none')
          .text(d[sky.refColumn])

          y_ = y_ - sky.height - (sky.gap * 2)

          // Draw the number of box per Month
          if(i == periodData.length-1) {
            this.boxGroup = this.canvasSkyline
            .append('text')
            .attr('class', 'Period_Count')
            .attr('transform', () => {
              if (i >= sky.maxBox) {
                return `translate(${x1 + (width_/2) - (((this.skyline.width + (this.skyline.gap * 2)) / 2) * (w.col - 1))}, ${this.timeline.y - (sky.height + (sky.gap * 2)) * sky.maxBox - 2})`
              } else {
                return `translate(${x1 + (width_/2)}, ${y_ + sky.height - 2})`
              }
            })
            .style('font-size', 10).style('fill', '#757575').attr('visibility', 'visible')
            .attr('text-anchor', 'middle')
            .text(periodData.length)
          }
        })

        boxX += sky.width + (sky.gap * 2)
      })


    },

  }
}
